module.exports = __webpack_public_path__ + "img/feature_c02.dbcc8550.svg";